<template>
  <div class="login_container">
    <div class="tips_box"  v-show="!dialogVisible">
      <div class="avatar_box">WARNING（预防针）</div>
      <div class="text_box">
        &nbsp;&nbsp;*它是个验证技术型学习类网站，主要作用是为了验证技术<br/>
        &nbsp;&nbsp;*它还在迭代中，可能存在验证类问题<br/>
        &nbsp;&nbsp;*它注册需要联系开发者提供一次性注册码<br/>
        &nbsp;&nbsp;*它使用的技术栈见<el-link @click='toNavigat' :underline='false' target='_blank' class="navigat">导航页</el-link><br/>
        &nbsp;&nbsp;*欢迎指导、交流、讨论、学习<br/>
        &nbsp;&nbsp;*微信公众号&微信小程序：<br/>
      </div>
      <div class="pic_box">
        <img class="pic" src='../assets/qrcode.jpg'/>
        <img class="pic" src='../assets/gh_037289c1720d_258.jpg'/>
      </div>
      <p class="char_box">
         __      _____________       _______________________________   ___ ___<br/>
        /  \    /  \_   _____/       \__    ___/\_   _____/\_   ___ \ /   |   \<br/>
        \   \/\/   /|    __)_   ______ |    |    |    __)_ /    \  \//    ~    \<br/>
         \        / |        \ /_____/ |    |    |        \\     \___\    Y    /<br/>
          \__/\  / /_______  /         |____|   /_______  / \______  /\___|_  /<br/>
               \/          \/                           \/         \/       \/<br/>
      </p>
    </div>
    <div class="login_box" v-show="!dialogVisible">
      <!-- 头像区域 -->
      <div class="avatar_box">登录</div>

      <!-- 登录表单区 -->
      <el-form
        ref="loginFormref"
        :model="loginForm"
        class="login_form"
        :rules="loginformrules"
      >
        <!-- 用户名 -->
        <el-form-item prop="loginName">
          <el-input
            prefix-icon="el-icon-user"
            v-model="loginForm.loginName"
          ></el-input>
        </el-form-item>

        <!-- 密码 -->
        <el-form-item prop="password">
          <el-input
            prefix-icon="el-icon-lock"
            v-model="loginForm.password"
            type="password"
            show-password
          ></el-input>
        </el-form-item>

        <!-- 验证码 -->

        <div class="verify_code">
            <el-form-item prop="verifyCode" class="verify_code_item">
              <el-input v-model="loginForm.verifyCode"></el-input>
            </el-form-item>
            <img :src="verifyCodeUrl" @click="getVerifyCode" class="verify_code_img">
            <!-- <el-image :src="verifyCodeUrl" @click="getVerifyCode" class="verify_code_img"></el-image>> -->
        </div>

        <!-- 按钮区域 -->
        <el-form-item class="btns">
          <el-button type="primary" @click="login">登录</el-button>
          <el-button @click="toRegister">注册</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 注册提示框 -->
    <el-dialog
      title="注册账号"
      :visible.sync="dialogVisible"
      width="30%"
      :modal-append-to-body="false"
      @close="reset()"
    >
      <!-- 注册内容 -->
      <el-form
        :model="registerForm"
        :rules="loginformrules"
        ref="registerFormref"
        label-width="100px"
      >
        <el-form-item label="用户名" prop="registName">
          <el-input
            v-model="registerForm.registName"
            style="width: 75%"
          ></el-input>
        </el-form-item>

        <el-form-item label="密码" prop="registWord">
          <el-input
            type="password"
            v-model="registerForm.registWord"
            style="width: 75%"
            show-password
          ></el-input>
        </el-form-item>

        <el-form-item label="确认密码" prop="repassword">
          <el-input
            type="repassword"
            v-model="registerForm.repassword"
            style="width: 75%"
            show-password
          ></el-input>
        </el-form-item>

        <el-form-item label="注册码" prop="recommendCode">
          <el-input
            v-model="registerForm.recommendCode"
            style="width: 75%"
          ></el-input>
        </el-form-item>
      </el-form>

      <!-- 底部 -->
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="register()"> 确 定 </el-button>
        <el-button @click="reset()">重置</el-button>
      </span>
    </el-dialog>

    <el-dialog title="温馨提示"
      :visible.sync="tipsVisible"
      width="30%"
      :modal-append-to-body="false">
      <h3>首页放置了陷阱纹，请勿在登录页面停留太久，以免造成不适哦！</h3>
      <h1>{{ seconds }}</h1>
    </el-dialog>
  </div>
</template>

<script>
// import qs from 'qs'
import bcrypt from 'bcryptjs'
export default {
  data () {
    return {
      // 这是登录表单的数据绑定对象
      loginForm: {
        loginName: '',
        password: '',
        verifyCode: '',
        time: ''
      },
      // 这是表单的验证对象
      loginformrules: {
        // 验证用户名是否合法
        loginName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          {
            min: 3,
            max: 15,
            message: '长度在 3 到 15 个字符',
            trigger: 'blur'
          }
        ],
        // 验证用户名是否合法
        registName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          {
            min: 3,
            max: 15,
            message: '长度在 3 到 15 个字符',
            trigger: 'blur'
          }
        ],
        // 验证密码是否合法
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          {
            min: 6,
            max: 15,
            message: '长度在 6 到 15 个字符',
            trigger: 'blur'
          }
        ],
        // 验证密码是否合法
        registWord: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          {
            min: 6,
            max: 15,
            message: '长度在 6 到 15 个字符',
            trigger: 'blur'
          }
        ],
        // 验证码是否合法
        verifyCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          {
            min: 0,
            max: 6,
            message: '长度在 0 到 6 个字符',
            trigger: 'blur'
          }
        ],
        repassword: [
          { required: true, message: '确认密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请再次输入密码'))
              } else if (value !== this.registerForm.registWord) {
                callback(new Error('两次输入密码不一致'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      },
      // 注册对话框显示
      dialogVisible: false,
      // 注册的用户数据
      registerForm: {
        registName: '',
        registWord: '',
        repassword: '',
        recommendCode: ''
      },
      verifyCodeUrl: '',
      cookie: '',
      tipsVisible: false,
      seconds: 5
    }
  },
  mounted () {},
  created () {
    // 回车登录
    var t = this
    document.onkeydown = function (e) {
      var key
      if (window.event === undefined) {
        key = e.keyCode
      } else {
        key = window.event.keyCode
      }
      // enter的ASCII码是13
      if (key === 13) {
        // t.登录方法
        t.login()
      }
    }
    this.getVerifyCode()
    this.tipsVisible = true
    this.timer()
  },
  methods: {
    // 重置表单内容
    async getVerifyCode () {
      const time = Date.now()
      const { data: res } = await this.$http.get('/verify/getVerifyCode/' + time, { responseType: 'arraybuffer' })
      console.info('getVerifyCode.res:' + res)
      if (res === null) {
        return this.$message.error('获取验证码失败！')
      }
      let codeUrl = 'data:image/jpg;base64,' + this.arrayBufferToBase64(res)
      this.cookie = document.cookie
      this.verifyCodeUrl = codeUrl
      this.loginForm.time = time
    },

    // 登录实现
    login () {
      this.$refs.loginFormref.validate(async (valid) => {
        // 加密密码
        const md5Password = this.$md5(this.loginForm.password)
        const saltRounds = 10
        const hashedPassword = await bcrypt.hash(md5Password, saltRounds)
        console.log('hashedPassword: ' + hashedPassword)
        if (!valid) return
        const { data: res } = await this.$http.post(
          '/manage/login',
          {
            loginName: this.loginForm.loginName,
            password: hashedPassword,
            verifyCode: this.loginForm.verifyCode,
            time: this.loginForm.time
          }
        )
        // 重刷验证码
        this.getVerifyCode()
        // const { data: res } = await this.$http.post('login', this.loginForm);
        console.log('res.code: ' + res.code)
        console.log('res.message: ' + res.message)
        if (res.code !== 1) {
          return this.$message.error(res.message)
        }
        this.oldName = this.$route.params.oldName
        if (this.oldName === null || this.oldName === undefined) {
          this.oldName = 'home'
        }
        window.sessionStorage.setItem('token', res.body.token)
        if (res.body.type === '0') {
          // token是登录的凭证，保存在sssionStorage中
          window.sessionStorage.setItem('showAdmin', true)
          // 通过编程式导航跳转到后台页面 路由地址是/home
          this.$router.push({ name: this.oldName, params: { showadmin: true } })
        } else {
          window.sessionStorage.setItem('showAdmin', false)
          // 通过编程式导航跳转到后台页面 路由地址是/home
          this.$router.push({ name: this.oldName, params: { showadmin: false } })
        }
        console.log(res.body.type)
      })
    },

    // 重置表单内容
    reset () {
      this.$refs.registerFormref.resetFields()
    },

    // 注册用户
    register () {
      this.$refs.registerFormref.validate(async (valid) => {
        // 加密密码
        const hashedPassword = this.$md5(this.registerForm.registWord)
        // 预校验通过可以发起注册的网络请求
        if (!valid) return
        const { data: res } = await this.$http.post(
          '/user/register',
          {
            loginName: this.registerForm.registName,
            password: hashedPassword,
            recommendCode: this.registerForm.recommendCode
          }
        )
        if (res.code !== 1) {
          return this.$message.error(res.message)
        }
        this.$message.success('注册成功！')
        this.dialogVisible = false
      })
    },

    // 二进制转base64
    arrayBufferToBase64 (buffer) {
      var binary = ''
      var bytes = new Uint8Array(buffer)
      var len = bytes.byteLength
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i])
      }
      return window.btoa(binary)
    },

    // 定时器
    timer () {
      var interval = setInterval(() => {
        this.seconds -= 1
        if (this.seconds <= 0) {
          this.closeTips()
          clearInterval(interval)
        }
      }, 1000)
    },

    // 关闭提示框
    closeTips () {
      this.tipsVisible = false
    },

    // 跳转导航页面
    toNavigat () {
      this.$router.push('/navigation')
    },

    // 打开注册窗口
    toRegister () {
      this.dialogVisible = true
    }
  }
}
</script>

<style lang='less' scoped>
.login_container {
  background: url(../assets/1.jpg);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-width: 1000px;
  zoom: 1;
  background-color: #fff;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center 0;
}
.tips_box {
  width: 50%;
  height: 80%;
  position: absolute;
  left: 10%;
  top: 9%;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.5);
}
.tips_box .navigat {
  margin-top: -7px;
  font-size: 25px;
  font-weight: 500;
  letter-spacing: 2px;
  text-align: center;
  color: #409EFF;
}
.tips_box .avatar_box {
  margin: 20px auto 20px auto;
  font-size: 40px;
  font-weight: 600;
  letter-spacing: 2px;
  text-align: center;
  color: rgb(255, 255, 255);
}
.tips_box .text_box {
  margin: 15px auto 0 auto;
  font-size: 25px;
  font-weight: 500;
  letter-spacing: 2px;
  text-align: left;
  color: rgb(255, 255, 255);
}
.pic_box {
  text-align: left;
  padding-top: 20px;
}
.pic_box .pic {
  width: 150px;
  height: 150px;
  margin-left: 182px;
}
.tips_box .char_box {
  white-space: pre;
  font-family: cursive;
  line-height: 10px;
  margin: 15px auto 0 auto;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 2px;
  text-align: left;
  color: rgb(255, 255, 255);
}
.login_box {
  width: 350px;
  height: 300px;
  position: absolute;
  left: 75%;
  top: 9%;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.5);
}

.login_box .avatar_box {
  margin: 15px auto 0 auto;
  font-size: 25px;
  font-weight: 500;
  letter-spacing: 8px;
  text-align: center;
  color: rgb(255, 255, 255);
}

.btns {
  display: flex;
  justify-content: left;
}

.btns .el-button {
  width: 148px;
  letter-spacing: 8px;
}

.btns > div {
  display: contents!important;
}

.login_form {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}
.verify_code_item {
  width: 50%;
  float: left;
}
.verify_code_img {
  width: 50%;
  float: right;
  height: 40px;
  line-height: 40px;
  margin-left: 5px !important;
}

.verify_code {
  display: flex;
  justify-content: left;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue